import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Workflow from '../components/Workflow';
import Services from '../components/Services';
import AiTeaser from '../components/AiTeaser';
import Industries from '../components/Industries';
import Technologies from '../components/Technologies';
import PortfolioTeaser from '../components/PortfolioTeaser';
import TrustBadges from '../components/TrustBadges';
import FAQ from '../components/FAQ';
import AboutTeaser from '../components/AboutTeaser';

const Home = () => {
  useEffect(() => {
    document.title = "Businex – Innovative IT Solutions & AI Studio";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Businex delivers enterprise AI, Conversational RAG, Cloud, and Data solutions. Explore our AI Studio and portfolio of custom case studies.");
    }
  }, []);

  return (
    <div>
      <Hero />
      <AboutTeaser />
      <Workflow />
      <Services />
      <AiTeaser />
      <PortfolioTeaser />
      <TrustBadges />
      <Industries />
      <Technologies />
      <FAQ />
    </div>
  );
};

export default Home;
